// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3GjaV","row":"ProcedureTreatmentSummary_row__3U1t5"};